function initiateColorsAndSizes(isPopup) {

  const prefix = isPopup === 1 ? '.modal--quickshop-full ' : '';

  /* ===================== ORDER SIZES ===================== */

  const moreSizes = document.querySelector(prefix + '.moreColors.sizes');
  if (moreSizes) {
    const links = Array.from(moreSizes.querySelectorAll('a'));

    links.sort((a, b) => {
      const an = parseInt(a.getAttribute('ord'), 10);
      const bn = parseInt(b.getAttribute('ord'), 10);
      return an - bn;
    });

    links.forEach(a => moreSizes.appendChild(a));
  }

  /* ===================== COLORS ===================== */

  const colorsContainer = document.querySelector(prefix + '.moreColors.colors');
  const colorLinks = colorsContainer
    ? Array.from(colorsContainer.querySelectorAll('a'))
    : [];

  if (colorLinks.length > 0) {
    colorsContainer.classList.remove('hidden');

    const selectedColorEl = colorsContainer.querySelector('a.selected');
    let listOfColors = selectedColorEl
      ? selectedColorEl.getAttribute('cor') + ','
      : '';

    colorLinks.forEach(a => {
      if (!a.classList.contains('selected')) {
        const cor = a.getAttribute('cor') + ',';
        if (listOfColors.indexOf(cor) === -1) {
          listOfColors += cor;
        } else {
          a.classList.add('hidden');
        }
      }
    });
  }

  /* ===================== SIZES ===================== */

  const sizesContainer = document.querySelector(prefix + '.moreColors.sizes');
  const sizeLinks = sizesContainer
    ? Array.from(sizesContainer.querySelectorAll('a'))
    : [];

  if (sizeLinks.length > 0) {
    sizesContainer.classList.remove('hidden');

    if (colorLinks.length > 0) {
      const selectedColor = colorsContainer
        ?.querySelector('a.selected')
        ?.getAttribute('cor');

      sizeLinks.forEach(a => {
        if (a.getAttribute('cor') !== selectedColor) {
          a.classList.add('hidden');
        }
      });
    }
  }

  /* ===================== REMOVE DUPLICATE COLORS ===================== */

  const seenColors = {};
  colorLinks.forEach(a => {
    const prodId = a.getAttribute('prodid');
    if (seenColors[prodId]) {
      a.remove();
    } else {
      seenColors[prodId] = true;
    }
  });

  /* ===================== REMOVE DUPLICATE SIZES ===================== */

  const seenSizes = {};
  sizeLinks.forEach(a => {
    const prodId = a.getAttribute('prodid');
    if (seenSizes[prodId]) {
      a.remove();
    } else {
      seenSizes[prodId] = true;
    }
  });

  /* ===================== TITLES ===================== */

  const selectedColor = colorsContainer
    ?.querySelector('a.selected')
    ?.getAttribute('cor');

  if (selectedColor) {
    const title = colorsContainer.querySelector('.moreColorsTitle');
    if (title) {
      title.innerHTML = 'Cores:<b> (Cor ' + selectedColor + ')</b>';
    }
  }

  const selectedSize = sizesContainer
    ?.querySelector('a.selected')
    ?.getAttribute('tam');

  if (selectedSize) {
    const title = sizesContainer.querySelector('.moreColorsTitle');
    if (title) {
      title.innerHTML = 'Tamanhos:<b> (Tamanho ' + selectedSize + ')</b>';
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
 if (window.location.pathname.indexOf("/products/") != -1){
      setTimeout(function(){initiateColorsAndSizes(0);},400);
    }
});